<template>
    <div class="product_services main_width m_0 main_color">
        <div class="title">全链路产品线与服务</div>
        <div class="tab_list">
            <div v-for="(item, index) in tabList" :key="index" :class="item.id == tabId && 'acttive'" @click="clickTab(item.id)">
                {{ item.title }}
            </div>
        </div>
        <!-- 汽修宝 -->
        <transition name="fade">
            <div class="content_box qxb" v-show="tabId == 1">
                <div class="content">
                    <div class="qxb_title">汽修宝（智能数据查询工具）</div>
                    <p style="margin-bottom: 16px;">国内首个以车架号（VIN）免费查询为核心的汽配数据工具，覆盖3.3亿人工校验VIN数据、90+品牌EPC原厂结构图及3000万+OE零件号，提供维修记录、出险记录、AI智能诊断等一站式服务。</p>
                    <p>1.行业最全数据：VIN/OE/EPC覆盖率超98%，新能源车型查询精准适配。</p>
                    <p>2.AI智能识别：支持拍照识别车架号、故障码诊断，并推荐维修方案与配件购买。</p>
                    <p style="margin-bottom: 12px;">3.高频刚需工具：日活超25万+，累计服务3500万用户，覆盖维修厂、汽配商、二手车商、车主等多角色</p>
                    <img src="../../../static/images2/app.png" alt="">
                    <div class="qxb_dow">手机APP下载</div>
                </div>
                <div class="qxb_img">
                    <img
                        v-if="isMinView"
                        src="../../../static/images2/h5/qxb.webp"
                        alt=""
                    >
                    <img
                        v-else
                        src="../../../static/images2/qxb.png"
                        alt=""
                    >
                </div>
            </div>
        </transition>
        <!-- 数字云仓系统 -->
        <transition name="fade">
            <div class="content_box cloud_warehouse" v-show="tabId == 2">
                <div class="content">
                    <div class="cloud_warehouseb_title">数字云仓（清库存利器-供应链管理系统）</div>
                    <p style="margin-bottom: 16px;">为汽配商打造的智能ERP系统，实现库存管理、订单协同、供应链优化，无缝对接汽修宝数据平台，缩短交易链路，提升周转效率30%以上。</p>
                    <p>1.实时库存同步：查询配件后直接跳转库存管理，支持一键生成报价单。</p>
                    <p>2.智能库存预警：基于历史销售数据预测需求，自动推荐补货策略。</p>
                    <p>3.多端协同闭环：支持PC、APP、小程序多端交易闭环。</p>
                </div>
                <div class="cloud_warehouse_img">
                    <img src="../../../static/images2/CloudWarehouse.png" alt="">
                </div>
            </div>
        </transition>
        <!-- 配件查询/销售系统 -->
        <transition name="fade">
            <div class="content_box trading_platform" v-show="tabId == 3">
                <div class="content">
                    <div class="trading_platform_title">交易平台（打造全球最大汽配交易电商平台）</div>
                    <p style="margin-bottom: 16px;">整合汽配厂家资源的线上交易市场，提供拆车件、原厂件、品牌件等全品类配件交易，支持求购报价、会员专享价、积分兑换等多元化服务。</p>
                    <p>1.精准撮合：AI自动匹配求购需求与供应商库存，秒报价秒交易。</p>
                    <p>2.会员特权：金卡会员享专属折扣、优先展示商品及共享权益，提升交易转化率。</p>
                    <p>3.全流程保障：支持在线支付、实时分账、物流跟踪、售后无忧，打造“查-买-装”闭环体验。</p>
                </div>
                <div class="trading_platform_img">
                    <img src="../../../static/images2/trading_platform.webp" alt="">
                </div>
            </div>
        </transition>
        <!-- API数据对接服务 -->
        <transition name="fade">
            <div class="content_box API" v-show="tabId == 4">
                <div class="content">
                    <div class="API_title">API数据对接服务</div>
                    <p>API数据对接服务-汽修宝提供全方位的车辆数据信息查询接口对接服务，包括VIN车架号查询接口、EPC车辆结构图接口、OE零件号查询接口、原厂数据查询接口、维修保养记录查询接口、出险理赔记录查询接口和车辆状况查询接口等。除此之外，还有多种广告位供商家选择投放。</p>
                </div>
                <div class="API_img">
                    <img src="../../../static/images2/API.webp" alt="">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { isMinView } from '../../utils/index.js'
export default {
    name: 'product-services',
    data() {
        return {
            tabId: 1,
            tabList: [
                {
                    id: 1,
                    title: '汽修宝'
                },
                {
                    id: 2,
                    title: '数字云仓系统'
                },
                {
                    id: 3,
                    title: '配件查询/销售系统'
                },
                {
                    id: 4,
                    title: 'API数据对接服务'
                },
            ],
            isMinView: isMinView(),
        }
    },
    created() {
        console.log(this.isMinView)
    },
    methods: {
        clickTab(id) {
            this.tabId = id
        }
    }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
.product_services {
    margin-top: .px2vw(28)[@result];
    text-align: justify;
    .title {
        text-align: center;
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(24)[@result];
    }
    .tab_list {
        font-size: .px2vw(16)[@result];
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: .px2vw(16)[@result];
        & > div {
            margin: 0 .px2vw(28)[@result];
            position: relative;
            cursor: pointer;
        }
        .acttive {
            font-weight: 500;
            color: #165DFF;
            &:after{
              width: 100%;
              height: 2px;
              background: #165DFF;
              content: '';
              position: absolute;
              bottom: .px2vw(-12)[@result];
              left: 50%;
              transform: translate(-50%,0);
            }
        }
    }
    .content {
        font-size: .px2vw(14)[@result];
        color: #4E5969;
        line-height: .px2vw(22)[@result];
        text-align: left;
        img {
            width: .px2vw(140)[@result];
            height: .px2vw(140)[@result];
        }
    }
    .content_box {
        height: .px2vw(552)[@result];
        box-sizing: border-box;
    }
    .qxb {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .px2vw(26)[@result] .px2vw(24)[@result] 0;
        & > .content {
            flex: 0 0 .px2vw(416)[@result];
            p {
                width: .px2vw(406)[@result];
                text-align: justify;
            }
        }
        .qxb_title {
            font-weight: 700;
            font-size: .px2vw(32)[@result];
            color: #1D2129;
            margin-bottom: .px2vw(24)[@result];
        }
        .qxb_img {
            img {
                max-width: .px2vw(781)[@result];
                max-height: .px2vw(446)[@result];
                object-fit: cover;
            }
        }
        .qxb_dow {
            font-size: .px2vw(16)[@result];
            margin-top: .px2vw(8)[@result];
            margin-left: .px2vw(23)[@result];
        }
    }
    .cloud_warehouse {
        display: flex;
        align-items: center;
        justify-content: center;
        & > .content {
            flex: 0 0 .px2vw(405)[@result];
            p {
                width: .px2vw(378)[@result];
                text-align: justify;
            }
        }
        .cloud_warehouseb_title {
            font-weight: 700;
            font-size: .px2vw(22)[@result];
            color: #1D2129;
            margin-bottom: .px2vw(24)[@result];
        }
        .cloud_warehouse_img {
            padding: .px2vw(26)[@result] 0 0 .px2vw(90)[@result];
            background: #F5F9FF;
            border-radius: .px2vw(10)[@result];
            margin-left: .px2vw(28)[@result];
            img {
                width: .px2vw(702)[@result];
                height: .px2vw(470)[@result];
            }
        }
    }
    .trading_platform {
        display: flex;
        align-items: center;
        justify-content: center;
        .trading_platform_title {
            font-weight: 700;
            font-size: .px2vw(22)[@result];
            color: #1D2129;
            margin-bottom: .px2vw(24)[@result];
        }
        & > .content {
            flex: 0 0 .px2vw(440)[@result];
            p {
                width: .px2vw(378)[@result];
                text-align: justify;
            }
        }
        img {
            width: .px2vw(625)[@result];
            height: .px2vw(305)[@result];
            margin-left: .px2vw(26)[@result];
        }
    }
    .API {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 .px2vw(24)[@result];
        .API_title {
            font-weight: 700;
            font-size: .px2vw(22)[@result];
            color: #1D2129;
            margin-bottom: .px2vw(24)[@result];
        }
         & > .content {
            flex: 0 0 .px2vw(378)[@result];
            p {
                text-align: justify;
            }
        }
        img {
            width: .px2vw(380)[@result];
            height: .px2vw(508)[@result];
            margin-left: .px2vw(350)[@result];
        }
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

@media screen and (max-width: 900px) {
    div {
        box-sizing: border-box;
    }
    .product_services {
        margin-top: .h5px2vw(32)[@result];
        .title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(32)[@result];
        }
        .tab_list {
            font-size: .h5px2vw(28)[@result];
            margin-bottom: .h5px2vw(24)[@result];
            flex-wrap: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            justify-content: flex-start;
            scrollbar-width: none;
            -ms-overflow-style: none;
            &::-webkit-scrollbar {
                display: none;
            }
            & > div {
                height: .h5px2vw(92)[@result];
                line-height: .h5px2vw(92)[@result];
                margin: 0 .h5px2vw(28)[@result];
                flex: 1 0 auto;
            }
            .acttive {
                &:after{
                    bottom: .h5px2vw(0)[@result];
                }
            }
        }
        .content {
            font-size: .h5px2vw(28)[@result];
            line-height: .h5px2vw(36)[@result];
            padding: 0 .h5px2vw(24)[@result];
            width: 100% !important;
            text-align: center;
            p {
                width: 100% !important;
            }
            img {
                width: .h5px2vw(140)[@result];
                height: .h5px2vw(140)[@result];
            }
        }
        .content_box {
            height: auto;
            flex-direction: column-reverse;
        }
        .qxb {
            padding: 0;
            .qxb_title {
                font-size: .h5px2vw(28)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                margin-top: .h5px2vw(24)[@result];
            }
            & > .content {
                img {
                    display: none;
                }
            }
            .qxb_img {
                padding: 0 .h5px2vw(56)[@result];
                border-radius: .h5px2vw(10)[@result];
                margin-left: 0;
                img {
                    max-width: 100%;
                    max-height: .h5px2vw(364)[@result];
                }
            }
            .qxb_dow {
                display: none;
            }
        }
        .cloud_warehouse {
            padding: 0;
            padding-bottom: .h5px2vw(32)[@result];
            & > .content {
                p {
                    width: 100% !important;
                }
            }
            .cloud_warehouseb_title {
                font-size: .h5px2vw(28)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                margin-top: .h5px2vw(24)[@result];
            }
            .cloud_warehouse_img {
                padding: 0 .h5px2vw(32)[@result];
                margin: 0;
                img {
                    width: 100%;
                    height: .h5px2vw(425)[@result];
                }
            }
        }
        .trading_platform {
            padding-bottom: .h5px2vw(32)[@result];
            .trading_platform_title {
                font-size: .h5px2vw(28)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                margin-top: .h5px2vw(24)[@result];
            }
            & > .content {
                p {
                    width: 100% !important;
                }
            }
            .trading_platform_img {
                padding: 0 .h5px2vw(32)[@result];
                img {
                    width: 100%;
                    height: .h5px2vw(336)[@result];
                    margin-left: 0;
                }
            }
        }
        .API {
            padding: 0;
            padding-bottom: .h5px2vw(32)[@result];
            .API_title {
                font-size: .h5px2vw(28)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                margin-top: .h5px2vw(24)[@result];
            }
            .API_img {
                padding: 0 .h5px2vw(239)[@result];
                img {
                    width: 100%;
                    height: .h5px2vw(364)[@result];
                    margin-left: 0;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/productServices.vue